import { render, staticRenderFns } from "./MarqueeTable.vue?vue&type=template&id=0933cbcc"
import script from "./MarqueeTable.vue?vue&type=script&lang=js"
export * from "./MarqueeTable.vue?vue&type=script&lang=js"
import style0 from "./MarqueeTable.vue?vue&type=style&index=0&id=0933cbcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports